module.exports = __webpack_public_path__ + "img/plus.298c7ec8.svg";